import { apiRequest } from '@/shared/api';
import type { PracticeKind, PracticeScenario } from '../model/types';

export function fetchPracticeScenarios(kind: PracticeKind): Promise<PracticeScenario[]> {
  return apiRequest<{ items: PracticeScenario[] }>(`/practice/${kind}`).then((res) => res.items);
}

/** Одна карточка целиком — экран-превью перед стартом (см. RoleplayDetailPage). */
export function fetchPracticeScenario(id: number): Promise<PracticeScenario> {
  return apiRequest<PracticeScenario>(`/practice/scenario/${id}`);
}

/** Снимает бейдж «Новое» на сервере — снаружи зовут `markScenarioSeen` (он же правит кеш). */
export function postScenarioSeen(id: number): void {
  void apiRequest(`/practice/${id}/seen`, { method: 'POST' }).catch(() => {
    // Не мешаем открытию карточки, если отметка не долетела — это не критично.
  });
}

